"use client";
import { cn } from "utils";
import dynamic from 'next/dynamic'

const HomeVerified = dynamic(() => import("@/components").then(({HomeVerified}) => HomeVerified));

const Page = () => {

  const pageName = 'home'


  return (
    <div 
      className={cn('relative')}
      data-markers={pageName}
    >
      <div className="scrol-start absolute top-[80px] md:top-[70px] " />
      <HomeVerified />
    </div>
  )
}

export default Page;